import Vue from 'vue'

import VxTooltip from 'components/dashboard/vx-tooltip/VxTooltip.vue'
import VxCard  from 'components/dashboard/vx-card/VxCard.vue'
import VxList  from 'components/dashboard/vx-list/VxList.vue'
import VxBreadcrumb  from 'components/dashboard/VxBreadcrumb.vue'
import FeatherIcon  from 'components/dashboard/FeatherIcon.vue'

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);